class MediaItemVideo extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('[data-video-trigger]');
    this.lightbox = this.querySelector('[data-video-lightbox]');
    this.previewVideo = this.querySelector('.media-item__video');
    this.lightboxVideo = this.querySelector('.media-item__lightbox-video');
    this.closeTargets = Array.from(this.querySelectorAll('[data-video-close]'));
  }

  connectedCallback() {
    this.trigger?.addEventListener('click', this.open);
    this.closeTargets.forEach((el) => {
      el.addEventListener('click', this.close);
    });
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.open);
    this.closeTargets.forEach((el) => {
      el.removeEventListener('click', this.close);
    });
    document.removeEventListener('keydown', this.handleKeydown);
  }

  open = () => {
    if (!this.lightbox) return;

    this.lightbox.hidden = false;
    this.previewVideo?.pause();
    this.lightboxVideo?.play();
    document.documentElement.classList.add('scroll-locked');
  };

  close = () => {
    if (!this.lightbox || this.lightbox.hidden) return;

    this.lightbox.hidden = true;
    this.lightboxVideo?.pause();
    if (this.lightboxVideo) this.lightboxVideo.currentTime = 0;
    this.previewVideo?.play();
    document.documentElement.classList.remove('scroll-locked');
    this.trigger?.focus();
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape') this.close();
  };
}

customElements.define('media-item-video', MediaItemVideo);
